module.exports = __webpack_public_path__ + "img/4064004460.88aa5b81.jpg";